import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import Flex from 'ui/Flex/Flex';
import { FormField } from 'components/Form/Form';
import { ChartSettingsT } from 'business/definitions';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import Selector from './Selector';

interface SortingSelectProps {
    field: FormField;
    onChange: (value: FormField['value']) => void;
}

const SortingSelect = ({ field, onChange }: SortingSelectProps) => {
    const { key, label, options, disabled } = field;

    const sortDimension = field.value as ChartSettingsT['sortDimension'];

    const onMetricChange = (dimension: string) => {
        if (!dimension) {
            onChange(undefined);
            return;
        }
        onChange({
            ...sortDimension,
            dimension,
            order: sortDimension?.order ?? 'desc',
        });
    };

    const onDirectionChange = (value: 'asc' | 'desc' | null) => {
        if (sortDimension?.dimension && value) {
            onChange({
                ...sortDimension,
                order: value,
            });
        }
    };

    return (
        <Flex justifyContent="space-between" width="100%" alignItems="center">
            <Selector
                key={key}
                sx={{ m: '8px 8px 8px 0' }}
                selectorId={key}
                label={label ?? ''}
                value={sortDimension?.dimension ?? ''}
                onChange={onMetricChange}
                options={options ?? []}
                disabled={disabled}
                preventSorting
                variant="outlined"
            />
            <ToggleButtonGroup
                color="primary"
                size="small"
                value={sortDimension?.order}
                onChange={(e, value) => onDirectionChange(value)}
                exclusive
                disabled={disabled}
            >
                <ToggleButton key="asc" value="asc">
                    <TrendingUpIcon fontSize="small" />
                </ToggleButton>
                <ToggleButton key="desc" value="desc">
                    <TrendingDownIcon fontSize="small" />
                </ToggleButton>
            </ToggleButtonGroup>
        </Flex>
    );
};

export default SortingSelect;
